export enum roleNameEnum {
  Admin = 'Admin',
  Manager = 'Manager',
  ReadOnly = 'Read Only',
  Contact = 'Contact',
  SUPER_ADMIN = "SUPER_ADMIN",
}

export enum statusesEnum {
  NotPosted = 1,
  Posted = 2,
  Failed = 3,
  GeneratingEmailContent = 4,
  DoNotRertyByProcessSendForVerification = 5,
  ErrorInGeneratingContent = 6,
  InvitationActive = 7,
  Inactive = 8,
  Pending = 9,
  Accepted = 10,
  Declined = 11,
  PendingVerification = 12,
  InitiatedVerification = 13,
  PendingManualVerification = 14,
  AutomatedVerified = 15,
  ManuallyVerified = 16,
  AutomatedRejected = 17,
  ManuallyRejected = 18,
  Opened = 19,
  InProgress = 20,
  Resolved = 21,
  ReOpened = 22,
  Deleted = 23,
  AccountConfirmationCode = 24,
  SMSSent = 25,
  Cancelled = 26,
  Active = 27,
  Expired = 28,
  CertificationNew = 29,
  CertificationRejected = 30,
  CertificationApproved = 31,
  Matched = 32,
  NotMatched = 33,
  NotFound = 34,
  TaskCompleted = 35,
  CertificateDownloaded = 36,
  ReportPaymentNew = 37,
  Submitted = 38,
  Accept = 58,
  Reject = 59,
  Tentative = 60,
  customerYesInclude = '1',
  customerYesNotInclude = '2',
}

export enum statusesNameEnum {
  Accept = 'Accepted',
  Reject = 'Rejected',
  Tentative = 'Tentative'
}

export enum statusesRadioEnum {
  Active = 1,
  Inactive = 2,
  All = 3,
}

export enum stausNameEnum {
  Active = 'Active',
  Expired = 'Expired',
  Verify = 'is_Verify',
  NotVerified = 'Not Verified',
  Current = 'Current',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Pending = 'Pending',
  ManuallyVerified = 'Manually Verified'
}
export enum stausImageStatusEnum {
  Active = 'true',
  Inactive = 'false',
}

export enum reportingStatusEnum {
  YetToOpen = 'YetToOpen',
  OpenforReporting = 'OpenForReporting',
  ClosedForReporting = 'ClosedForReporting',
  Locked = 'Locked',
}

export enum invitationType {
  Company = 1,
  User = 2,
  Event = 3,
  RTR = 4,
  Corporate = 5
}

export enum ethnicityOwnershipType {
  ChooseEthnicity = 'Choose Ethnicity',
  DoNotWishToDisclose = 'Don’t Wish To Disclose',
  PreferNotToAnswer = 'Prefer Not To Answer',
  Other = 'Other',
  MultiEthnic = 'Multi-Ethnic'
}


export enum requestType {
  Supplier = 1,
  Event = 2,
  Webiste = 3
}

export enum tierType {
  Tier1 = 1,
  Tier2 = 2,
  Tier1_Tier2 = 3
}

export enum exportExcelHeaderColors {
  IntialHeader = 'FAD9C8',
  ChildHeader = 'FAD9C8',
  IntialHeaderForeColor = '000000',
  ChildHeaderForeColor = '000000',
  InitialColumnSize = '40',
  minimumExcelCellWidth = '20',
  primeAnalyticsHeaderColor = 'DA9694'
}

export enum defaultValue {
  usCountryCode = 233,
  rejected = 'Rejected',
  accepted = 'Accepted',
  expired = 'Expired',
  cancelled = 'Cancelled',
  active = 'Active',
  draft = 'Draft',
  category = 'category',
  ethnicity = 'Ethnicity',
  defaultDisplayList = 'DefaultDisplayList',
  allCompany = 0,
  adminRoleId = '2',
  OpenForReporting = 'Open for reporting',
  new = 'New',
  none = 'None',
  move = 'Move',
  pending = 'Pending',
  reported = 'Reported',
  superAdmin = 'superAdmin',
  december = 'December',
  edit = 'Edit',
  bulkInvite = 'BulkInvite',
  admin = 'Admin',
  yes = 'Yes',
  isActive = 'isActive',
  no = 'No',
  default = 'Default',
  CAccess = 'C',
  CT1Access = 'CT1',
  T1Access = 'T1',
  T2Access = 'T2',
  checked = 'checkbox',
  company = 'company',
  primary = 'Primary',
  primaryReport = 'PrimaryReport',
  next = 'Next',
  previous = 'Previous',
  invite = 'Invite',
  approve = 'Approve',
  TierTwo = 'Tier 2',
  TierOne = 'Tier 1',
  SupplierCode = 'SupplierCode',
  SuperAdminCompanyId = '0',
  pdf = 'pdf',
  General = 'General',
  Analytics = 'Analytics',
  withContacts = 'withContacts',
  linkedIn = 'Linkedin',
  twitter = 'X(Twitter)',
  SupplierContacts = 'With Contacts',
  SupplierCertificates = 'With Certificates',
  ExportSupplier = 'Basic Info',
  apiErrorMsg = 'Something went wrong , please try again later',
  TypeofGoal = "TypeofGoal",
  dateInputFormat = 'MM/DD/YYYY',
  dateTimeInputFormat = 'MM/DD/YYYY, HH:MM AM',
  AvailbleSelectAll = "AvailbleSelectAll",
  Available = 'Available',
  create = 'Create',
  ReadOnly = 'Read Only',
  export = 'Export',
  addToFav = 'AddToFav',
  standard = 'Standard',
  add = 'Add',
  CustomReporting = 'Custom Reporting',
  Diversity = 'diversity',
  supplierActivityReport='Supplier Activity Report',
  invalidDate = 'Invalid Date',
  all = 'All',
  locked = 'Locked',
  verified = 'Verified',
  view = 'View',
  Pos = 'pos',
  PoSales = 'Percentage of Sales',
  PoPurchanges = 'Percentage of Purchases',
  both = 'Both',
  SA = 'SA',
  good = 'good',
  bad = 'bad',
  aggregateDefault = 1,
  aggreagteSettingKey ="AggregateGroupGroups"
}

export enum reportRequest {
  reportingFrequency = 'ReportingFrequency',
  financialYearEnding = 'FinancialYearEnding',
  dueByTimeZone = 'DueByTimeZone',
  dueByTime = 'DueByTime',
  reportingDuration = 'ReportingDuration',
  reportSettingStartDate = 'ReportSettingStartDate',
  draft = 'draft',
  statusNew = 'new',
  aggregate = 'aggregate'

}


export enum messageScreenNames {
  reportingRequest = 'Report Requests',
  reportRequest = 'Report Requests',
  quickLinks = 'Quick Links',
  directory = 'Directory',
  events = 'Events',
  settings = 'Settings',
  agencies = 'Agencies',
  certificateUpload = 'Certificate Upload',
  categoryKpi = 'Category KPI',
  spendGoals = 'Spend Goals',
  reportingDashboard = 'Reporting Dashboard',
  superAdminAggregateGroups = 'Super_Admin_Aggregate_Groups',
  superAdminDiversityTypes = 'Classification',
  superAdminEthnicity = 'Ethnicities',
  superAdminTaxTypes = 'Tax Types',
  companyProfile = 'Company Profile',
  companyCategories = 'Categories',
  notifications = 'Notifications',
  emailTemplates = 'Email Templates',
  supplierImport = 'Supplier Import',
  inviteSupplier = 'Invite Supplier',
  emailInvitation = 'Email Invitations',
  supplierGroups = 'Supplier Groups'
}

// Define the monthMap with specific types
export const monthMap: { [key: string]: number } = {
  january: 0,
  february: 1,
  march: 2,
  april: 3,
  may: 4,
  june: 5,
  july: 6,
  august: 7,
  september: 8,
  october: 9,
  november: 10,
  december: 11,
};


export enum superAdminPublish {
  All = 1,
  Admin = 2,
  Corporate = 3,
  Tier_1 = 4
}
